import { configureStore } from '@reduxjs/toolkit';
import newsRoutes from '../states/reducers/newsReducer';
import userReducer from '../states/reducers/userReducer';
import houseReducer from '../states/reducers/houseReducer';
import houseCategoryReducer from '../states/reducers/houseCategoryReducer';
import feedbackReducer from '../states/reducers/feedbackReducer';
import bookingReducer from '../states/reducers/bookingReducer';
import loginReducer from '../states/reducers/logingReducer';
import sidebarReducer from '../states/reducers/sidebarReducer';

const store = configureStore({
  reducer: {
    news: newsRoutes,
    users: userReducer,
    houses: houseReducer,
    houseCategory: houseCategoryReducer,
    feedback: feedbackReducer,
    booking: bookingReducer,
    userLogin: loginReducer,
    sidebar: sidebarReducer,
  },
});

export default store;
